<template>
    <a-row type="flex" justify="center">
        <a-col :span="12">
            <a-spin :spinning="leftloading">
                <a-result :status="status" :title="title" :sub-title="subTitle">
                    <!-- <template #icon>
                    <a-icon type="loading" theme="twoTone" />
                </template> -->
                    <div class="desc">
                        <a-form-model ref="ruleForm" :model="form" :rules="rules" :label-col="labelCol"
                            :wrapper-col="wrapperCol">
                            <a-form-model-item ref="phoneA" label="客户出行手机号" prop="phoneA">
                                <a-input-group compact>
                                    <a-input style="width: 80%" v-model="form.phoneA" placeholder="请输入客户实际出行手机号"
                                        :disabled="updateNoA.disabled" />
                                    <span>
                                        <a-button v-if="updateNoA.disabled" @click="updateNoA.disabled = false"
                                            v-permission="['admin:trip:updateSubscription?phoneA']">修改</a-button>
                                        <a-button :loading="updateNoA.loading"
                                            v-permission="['admin:trip:updateSubscription?phoneA']" v-else @click="updateBind('phoneA', 'updateNoA', {
                                                phoneNoA: form.phoneA,
                                            })">确认修改</a-button>
                                    </span>
                                </a-input-group>
                                <a-icon :style="{ color: 'red' }" type="question-circle" /> 请详细核对客户出行时的联系号码
                            </a-form-model-item>
                            <!-- <a-form-model-item ref="phoneB" label="行程备用手机号" prop="phoneB">
                                <a-input-group compact>
                                    <a-input v-model="form.phoneB" style="width: 80%;" placeholder="请输入"
                                        :disabled="secretBindDetailDTO.status !== null && updateNoB.disabled" />
                                    <template v-if="secretBindDetailDTO.status == 1">
                                        <a-button v-if="updateNoB.disabled" @click="updateNoB.disabled = false"
                                            v-permission="['admin:trip:updateSubscription?phoneB']">修改</a-button>
                                        <a-button :loading="updateNoB.loading" v-else
                                            v-permission="['admin:trip:updateSubscription?phoneB']" @click="updateBind('phoneB', 'updateNoB', {
                                                phoneNoB: form.phoneB,
                                            })">确认修改</a-button>
                                    </template>
                                </a-input-group>
                                <a-icon :style="{ color: 'red' }" type="question-circle" />
                                客户回拨隐私号码时没有任何可联系的号码时，隐私号会回拨这个号码
                            </a-form-model-item>
                            <a-form-model-item label="隐私通话过期时间" prop="expiration">
                                <a-input-group compact>
                                    <a-date-picker show-time style="width: 80%" :format="'YYYY-MM-DD HH:mm:ss'"
                                        :valueFormat="'YYYY-MM-DD HH:mm:ss'" v-model="form.expiration"
                                        :disabled="secretBindDetailDTO.status !== null && updateExpire.disabled"
                                        :disabled-date="disabledDate" />
                                    <template v-if="secretBindDetailDTO.status == 1">
                                        <a-button v-if="updateExpire.disabled" @click="updateExpire.disabled = false"
                                            v-permission="['admin:trip:updateSubscription?expiration']">修改</a-button>
                                        <a-button :loading="updateExpire.loading" v-else
                                            v-permission="['admin:trip:updateSubscription?expiration']" @click="updateBind('expiration', 'updateExpire', {
                                                expiration: form.expiration,
                                            })">确认修改</a-button>
                                    </template>
                                </a-input-group>
                                <a-icon :style="{ color: 'red' }" type="question-circle" /> 一般设置为行程结束时间（注意具体时间）
                            </a-form-model-item>
                            <a-form-model-item label="号码池" prop="pool_key">
                                <a-select v-model="form.pool_key" placeholder="请选择号码池" style="width: 80%;"
                                    :disabled="secretBindDetailDTO.status !== null || form.sub_id">
                                    <a-select-option v-for="(item, index) in poollist" :key="index"
                                        :value="item.pool_key" :disabled="item.disabled">{{ item.pool_name
                                        }}</a-select-option>
                                </a-select>
                            </a-form-model-item> -->
                        </a-form-model>

                        <!-- <p style="font-size: 16px;">
                        <strong>The content you submitted has the following error:</strong>
                    </p>
                    <p>
                        <a-icon :style="{ color: 'red' }" type="close-circle" /> Your account has been frozen
                        <a>Thaw immediately &gt;</a>
                    </p>
                    <p>
                        <a-icon :style="{ color: 'red' }" type="close-circle" /> Your account is not yet eligible to
                        apply <a>Apply Unlock &gt;</a>
                    </p> -->
                    </div>
                    <template #extra>
                        <!-- <a-button key="console" v-if="secretBindDetailDTO.status === null" type="primary"
                            @click="submitForm" :loading="submitFormLoading" v-permission="['admin:trip:bindTripAxg']">
                            确认开通
                        </a-button> -->
                        <!-- <a-button key="console" v-if="secretBindDetailDTO.status === 1" type="danger" @click="closeCall"
                            v-permission="['admin:trip:unbindSubscription']" :loading="closeLoading">
                            关闭当前行程隐私通话服务！
                        </a-button> -->
                        <a-button key="console" type="primary" @click="submitBindPhoneA"
                            :loading="submitBindPhoneALoading">
                            微信小程序邀请客户填写出行手机号
                        </a-button>
                    </template>
                </a-result>
            </a-spin>
        </a-col>
        <a-col :span="12" v-if="secretBindDetailDTO.status === 1">
            <a-tabs default-active-key="1" tabPosition="top">
                <a-tab-pane key="1" tab="工作人员号码组">
                    <grouplist :trip_id="trip_id" :group_id="group_id" :pool_key="form.pool_key"></grouplist>
                </a-tab-pane>
                <a-tab-pane key="2" tab="行程通话记录">
                    <calllog :trip_id="trip_id"></calllog>
                </a-tab-pane>
            </a-tabs>
        </a-col>
    </a-row>
</template>
<script>
import grouplist from './grouplist.vue';
import calllog from './calllog.vue';
export default {
    props: {
        trip_id: String,
        sub_id: String,
        group_id: String,
    },
    computed: {
        status() {
            return this.secretBindDetailDTO.status === null ? 'info' : this.secretBindDetailDTO.status === 1 ? 'success' : 'error'
        },
        title() {
            return this.secretBindDetailDTO.status === null ? '客户隐私通话待开启' : this.secretBindDetailDTO.status === 1 ? '客户隐私通话已开启' + `` : '客户隐私通话已失效'
        },
        subTitle() {
            return this.secretBindDetailDTO.status === null ? '如已确认会员开始行程，完善表达信息即可开启隐私号码功能' : this.secretBindDetailDTO.status === 1 ? '行程过程中工作人员和客户请用上述隐私号码联系，通话结束后会生成通话录音' : '当前隐私通话已失效'
        }
    },
    components: {
        grouplist,
        calllog
    },
    data() {
        return {
            submitBindPhoneALoading: false,
            form: {
                trip_id: this.trip_id,
                phoneA: "",
                // phoneB: "",
                // expiration: undefined,//有效时间
                // pool_key: undefined
            },
            updateNoA: {
                disabled: true,
                loading: false
            },
            updateNoB: {
                disabled: true,
                loading: false
            },
            updateExpire: {
                disabled: true,
                loading: false
            },
            disabledDate(current) {
                // 获取当前时间，并加上一分钟
                const oneMinuteLater = new Date();
                oneMinuteLater.setMinutes(oneMinuteLater.getMinutes() + 1);
                // 只能选择比 "当前时间 + 1 分钟" 之后的时间
                return current && current < oneMinuteLater;
            },
            rules: {
                phoneA: [
                    {
                        required: true,
                        message: "请输入客户出行手机号",
                        trigger: "change",
                    },
                    {
                        pattern: /^(1[3-9]\d{9}|[569]\d{7}|9\d{8})$/,
                        message: "请输入有效的大陆、港澳台手机号",
                        trigger: "change",
                    },
                ],
                phoneB: [
                    {
                        required: true,
                        message: "请输入行程主要负责人手机号",
                        trigger: "change",
                    },
                    {
                        pattern: /^(1[3-9]\d{9}|[569]\d{7}|9\d{8})$/,
                        message: "请输入有效的大陆、港澳台手机号",
                        trigger: "change",
                    },
                ],
                expiration: {
                    required: true,
                    message: "请选择隐私通过过期时间",
                    trigger: "change",
                },
                pool_key: {
                    required: true,
                    message: "请选择号码池",
                    trigger: "change",
                }
            },
            labelCol: { span: 6 },
            wrapperCol: { span: 18 },
            submitFormLoading: false,
            closeLoading: false,
            secretBindDetailDTO: {
                phoneNoX: "",
                status: null
            },
            leftloading: false,
        };
    },
    // watch: {
    //     sub_id: {
    //         handler(newValue) {
    //             if (newValue) {
    //                 this.getSubDetail()
    //             }
    //         },
    //         immediate: true
    //     }
    // },
    mounted() {
        this.getSubDetail()
    },
    methods: {
        copy(value) {
            const textarea = document.createElement('textarea');
            textarea.value = value;
            document.body.appendChild(textarea);
            textarea.select();
            document.execCommand('copy');
            document.body.removeChild(textarea);
            console.log('复制成功');
        },
        //邀请客户填写出行手机号
        submitBindPhoneA() {
            this.submitBindPhoneALoading = true
            this.$http({
                url: '/admin/trip/inviteCustomerPhoneA',
                method: "post",
                data: { trip_id: this.trip_id }
            }).then(res => {
                this.copy(res.data.invite_link);
                this.$success({
                    title: '生成邀请链接成功',
                    okText: "我已使用完毕，点击关闭",
                    content: (
                        <div>
                            <p>发送给客户的链接地址：</p>
                            <p>{res.data.invite_link}</p>
                            <p style='color: red'>已复制到剪切板，去粘贴发送给客户吧～</p>
                        </div>
                    ),
                });
            }).finally(() => {
                setTimeout(() => {
                    this.submitBindPhoneALoading = false
                }, 500);
            })
        },
        //获取号码绑定详情
        getSubDetail() {
            this.leftloading = true
            this.$http({
                url: '/admin/trip/querySubscriptionDetail',
                method: 'post',
                data: {
                    trip_id: this.trip_id,
                },
            }).then(res => {
                this.secretBindDetailDTO = res.data
                this.form.phoneA = res.data.phoneNoA
                this.form.phoneB = res.data.phoneNoB
                this.form.expiration = res.data.expireDate
                this.form.pool_key = res.data.pool_key
            }).finally(() => {
                this.leftloading = false
            })
        },
        submitForm() {
            this.$refs.ruleForm.validate(valid => {
                if (valid) {
                    this.submitFormLoading = true
                    this.$http({
                        url: '/admin/trip/bindTripAxg',
                        method: "post",
                        data: this.form
                    }).then(res => {
                        this.$message.success(res.message)
                        this.$emit('bindok')
                        this.getSubDetail()
                        this.$refs.ruleForm.resetFields();
                    }).finally(() => {
                        setTimeout(() => {
                            this.submitFormLoading = false
                        }, 500);
                    })
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        updateBind(fileId, operateType, updateData) {
            this.$refs.ruleForm.validateField(fileId, errors => {
                if (!errors) {
                    this[operateType].loading = true
                    this.$http({
                        url: '/admin/trip/updateSubscription',
                        method: 'post',
                        data: {
                            pool_key: this.form.pool_key,
                            phoneNoX: this.secretBindDetailDTO.phoneNoX,
                            subsId: this.sub_id,
                            operateType,
                            updateData: updateData,
                            trip_id: this.trip_id,
                        }
                    }).then(res => {
                        this[operateType].disabled = true;
                        this.$message.success(res.message)
                        this.getSubDetail()
                    }).finally(() => this[operateType].loading = false)
                } else {
                    this.$message.error("输入有误");
                }
            })
        },
        closeCall() {
            this.$confirm({
                title: '是否确认关闭 客户隐私通话 ，关闭后此行程将无法再次使用',
                content: '请认真确认！',
                onOk: () => {
                    this.closeLoading = true
                    this.$http({
                        url: '/admin/trip/unbindSubscription',
                        method: 'post',
                        data: {
                            pool_key: this.form.pool_key,
                            subsId: this.sub_id,
                            secretNo: this.secretBindDetailDTO.phoneNoX
                        }
                    }).then((res) => {
                        this.$message.success(res.message)
                        this.getSubDetail()
                    }).finally(() => this.closeLoading = false)
                },
            });
        }
    },
}
</script>